import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import { NavLink } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import Toolbar from '@mui/material/Toolbar';

import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import CategoryIcon from '@mui/icons-material/Category';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import HelpIcon from '@mui/icons-material/Help';
import RateReviewIcon from '@mui/icons-material/RateReview';
import AppsIcon from '@mui/icons-material/Apps';
import SettingsIcon from '@mui/icons-material/Settings';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import logo from '../images/miwf.png';

import ListAltIcon from '@mui/icons-material/ListAlt';

export default class CategoriesResults extends React.Component {
	
   
  
  render() {
    const docs = data.documents;
	const listItem = {
    height: 40,
  }
   const iconStyle = {
    fontSize: '20px',
  }	
   const navLink = {
    width: "100%",
  }
     return (
      <div>
			 <Toolbar sx={{ ml: 1 }}>
				  <Link href="/selectwatch/">
				  <Box
					component="img"
					sx={{ height: 35 }}
					alt="Logo"
					src={logo}
				  />
				</Link>
				</Toolbar>
			<Divider variant='middle' />
			
			<List component='nav' aria-labelledby='nested-list-subheader'>
		  
					  {docs.map(doc => {
						return (
						  <CustomizedListItem key={doc.typeid} doc={doc} />
						);
					  })}
		  		   
		  
               </List>    

				 <Divider variant='middle' />
		
				<List>
				
				<ListItem style={listItem}>
					<NavLink to="/ourapp" style={navLink}>
					  <ListItemButton className="item-btn" data-path="/ourapp">
						<ListItemIcon sx={iconStyle}>
						  <PhoneIphoneIcon />
						</ListItemIcon>
						<ListItemText primary="Our Apps" />
					  </ListItemButton>
					</NavLink>
				  </ListItem>
				  
				  
				<ListItem style={listItem}>
					<NavLink to="/scanguide" style={navLink}>
					  <ListItemButton className="item-btn" data-path="/scanguide">
						<ListItemIcon sx={iconStyle}>
						  <HelpIcon />
						</ListItemIcon>
						<ListItemText primary="QR Code Help" />
					  </ListItemButton>
					</NavLink>
				  </ListItem> 
				  
				
				  
				 <ListItem style={listItem}>
					<NavLink to="/firmware" style={navLink}>
					  <ListItemButton className="item-btn" data-path="/firmware">
						<ListItemIcon sx={iconStyle}>
						  <SettingsIcon />
						</ListItemIcon>
						<ListItemText primary="Firmware" />
					  </ListItemButton>
					</NavLink>
				</ListItem>
				  
				   <ListItem style={listItem}>
					<NavLink to="/contactform" style={navLink}>
					  <ListItemButton className="item-btn" data-path="/contactform">
						<ListItemIcon sx={iconStyle}>
						  <RateReviewIcon />
						</ListItemIcon>
						<ListItemText primary="Feedback" />
					  </ListItemButton>
					</NavLink>
				  </ListItem>
				  
				  
				</List>
		
				
				<div>
				<List sx={{ pl: 2, pb: 4 }}>

				  <ListItem>
					<Typography variant="caption"><a className="simple-link" href='/terms'>Terms & Condition</a></Typography>
				  </ListItem>
				  <ListItem>
					<Typography variant="caption"><a className="simple-link" href='/privacy'>Privacy Policy</a></Typography>
				  </ListItem>
				  <ListItem>
					<Typography variant="caption"><a className="simple-link"  href='/dmca'>DMCA</a></Typography>
				  </ListItem>
				   
				</List>
			  </div>
				
				
      </div>
    );
  }
}

 class CustomizedListItem extends React.Component {
  
   
  
	state = {};
		
	handleClick = (e,mymodel) => {
		
		console.log("mymodel "+e);
		if(mymodel !== undefined){
			localStorage["model"] = mymodel;
			//console.log("mymodel "+mymodel);			
		}
		this.setState({ [e]: !this.state[e] });
	  };
   

  render(){
	  
  const { doc } = this.props;
  
 
 const listItem = {
    height: 30,
	marginLeft: 30
  }
  const mainlistItem = {
	marginLeft: 15
  }
  return (
  
  
    <div>
	
	
      <ListItem button key={doc.typeid} onClick={(e) => this.handleClick(doc.typeid, doc.watchtype.model, e)}>
        <ListItemText primary={doc.typename} />
		
      </ListItem>
      <Collapse
        key={doc.watchtype.id}
        in={this.state[doc.typeid]}
        timeout='auto'
        unmountOnExit
      >
	  <ul>
      <List component='li' disablePadding key={doc.typeid}>
        {doc.watchtype?.map(sheet => {
          return (
		  <div>
           <ListItem style={mainlistItem} button key={sheet.id} onClick={(e) => this.handleClick(sheet.id, sheet.model, e)}>
			<ListItemText primary={sheet.category} />
			{this.state[sheet.id] ? <ExpandLess /> : <ExpandMore />}
		  </ListItem>
					
						<Collapse
							key={sheet.types.Id}
							in={this.state[sheet.id]}
							timeout='auto'
							unmountOnExit
						  >
						  <ul>
						  <List component='li' disablePadding key={sheet.id}>
							{sheet.types?.map(sheett => {
							  return (
								<ListItem style={listItem} button key={sheett.Id} component="a" href= { sheett.Id === 1 ? `/${sheet.model}/latest` : sheett.Id === 2 ? `/${sheet.model}/random` : sheett.Id === 3 ? `/${sheet.model}/category` :  sheett.Id === 4 ? `/${sheet.model}/search` : sheett.Id === 5 ? `/${sheet.model}/apps` : `/${sheet.model}/zeppwf`} >
								
								  <ListItemIcon>
									{  sheett.Id === 1 ? <FiberNewIcon /> : sheett.Id === 2 ? <ShuffleIcon /> : sheett.Id === 3 ? <CategoryIcon /> :  sheett.Id === 4 ? <SearchRoundedIcon /> : sheett.id === 5 ? <AppsIcon /> : <ListAltIcon /> }
								  </ListItemIcon>
								  <ListItemText key={sheett.Id}  primary={sheett.Title} />
								  
								</ListItem>
							  );
							})}
						  </List>
						  </ul>
						</Collapse>
			</div>	
          );
        })}
      </List>
	  </ul>
    </Collapse>
   
    </div>
	
	
    )
  }
}

const data = {
  "documents": 
  [
	{
		"typename": "Amazfit New Series",
		"typeid": 1000,
		"watchtype": [
			{
				"category": "Balance",
				"id": 11,
				"imageName": "balance",
				"imageNamew": "balance_w",
				"model": "balance",
				"name": "Balance",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Active",
				"id": 12,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "active",
				"name": "Active",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Active Edge",
				"id": 13,
				"imageName": "trex",
				"imageNamew": "trex_w",
				"model": "activee",
				"name": "Active Edge",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Cheetah",
				"id": 14,
				"imageName": "cheetah",
				"imageNamew": "cheetah_w",
				"model": "cheetah",
				"name": "Cheetah",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Cheetah Pro",
				"id": 15,
				"imageName": "cheetah",
				"imageNamew": "cheetah_w",
				"model": "cheetahpro",
				"name": "Cheetah Pro",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Cheetah Sqaure",
				"id": 16,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "cheetahsq",
				"name": "Cheetah Square",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Falcon",
				"id": 17,
				"imageName": "falcon",
				"imageNamew": "falcon_w",
				"model": "falcon",
				"name": "Falcon",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			}
		]
	},
	{
		"typename": "Amazfit GTR Series",
		"typeid": 2000,
		"watchtype": [
			{
				"category": "GTR 4",
				"id": 18,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr4",
				"name": "GTR 4",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 3",
				"id": 19,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr3",
				"name": "GTR 3",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 3 Pro",
				"id": 20,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr3pro",
				"name": "GTR 3 Pro",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 4 Mini",
				"id": 21,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtrmini",
				"name": "GTR Mini",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 2/2e",
				"id": 22,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr2",
				"name": "GTR 2/2e",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 47mm",
				"id": 23,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr47",
				"name": "GTR 47mm",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTR 42mm",
				"id": 24,
				"imageName": "gtr",
				"imageNamew": "gtr_w",
				"model": "gtr42",
				"name": "GTR 42mm",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			}
		]
	},
	{
		"typename": "Amazfit GTS Series",
		"typeid": 3000,
		"watchtype": [
			{
				"category": "GTS 4",
				"id": 25,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gts3",
				"name": "GTS 4/3",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTS 3",
				"id": 26,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gts3",
				"name": "GTS 3",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTS 4 Mini",
				"id": 27,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gts4mini",
				"name": "GTS 4 Mini",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "GTS 2/2e",
				"id": 28,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gts2",
				"name": "GTS 2/2e",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					}
				]
			},
			{
				"category": "GTS 2 Mini",
				"id": 29,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gtsmini",
				"name": "GTS 2 Mini",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					}
				]
			},
			{
				"category": "GTS",
				"id": 30,
				"imageName": "gts",
				"imageNamew": "gts_w",
				"model": "gts",
				"name": "GTS",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					}
				]
			}
		]
	},
	{
		"typename": "Amazfit Bip Series",
		"typeid": 4000,
		"watchtype": [
				{
				"category": "Bip 5",
				"id": 31,
				"imageName": "bip",
				"imageNamew": "bip_w",
				"model": "bip5",
				"name": "Bip 5",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 5,
						"Title": "Zepp Apps"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Bip 3",
				"id": 32,
				"imageName": "bip",
				"imageNamew": "bip_w",
				"model": "bip3",
				"name": "Bip 3/ Pro",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Bip U",
				"id": 33,
				"imageName": "bip",
				"imageNamew": "bip_w",
				"model": "bipu",
				"name": "Bip U/ Pro",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Bip S",
				"id": 34,
				"imageName": "bip",
				"imageNamew": "bip_w",
				"model": "bips",
				"name": "Bip S",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			},
			{
				"category": "Bip",
				"id": 35,
				"imageName": "bip",
				"imageNamew": "bip_w",
				"model": "bip",
				"name": "Bip",
				"types": [
					{
						"Id": 1,
						"Title": "Latest"
					},
					{
						"Id": 2,
						"Title": "Random"
					},
					{
						"Id": 3,
						"Title": "Category"
					},
					{
						"Id": 4,
						"Title": "Search"
					},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
				]
			}
		]
	},
	{
		"typename": "Amazfit T-rex Series",
		"typeid": 5000,
		"watchtype": [
		
					{
					"category": "T-Rex 2/Ultra",
					"id": 36,
					"imageName": "trex",
					"imageNamew": "trex_w",
					"model": "trex2",
					"name": "T-rex 2/Ultra",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
						{
							"Id": 5,
							"Title": "Zepp Apps"
						},
						{
							"Id": 6,
							"Title": "Zepp Watchface"
						}
					]
				},
				{
					"category": "T-Rex Pro",
					"id": 37,
					"imageName": "trex",
					"imageNamew": "trex_w",
					"model": "trexpro",
					"name": "T-rex Pro",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				},
				{
					"category": "T-Rex",
					"id": 38,
					"imageName": "trex",
					"imageNamew": "trex_w",
					"model": "trex",
					"name": "T-rex",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				}
		
		]
	},
{
		"typename": "Amazfit Other Watch",
		"typeid": 6000,
		"watchtype": [
		
					{
					"category": "Band 7",
					"id": 39,
					"imageName": "amab7_w",
					"imageNamew": "amab77_w",
					"model": "aband7",
					"name": "Amazfit Band 7",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
						{
							"Id": 5,
							"Title": "Zepp Apps"
						},
						{
							"Id": 6,
							"Title": "Zepp Watchface"
						}
					]
				},
				{
					"category": "Verge Lite",
					"id": 40,
					"imageName": "verge_w",
					"imageNamew": "verge_w",
					"model": "vergel",
					"name": "Verge Lite",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				},
				{
					"category": "Verge",
					"id": 41,
					"imageName": "verge_w",
					"imageNamew": "verge_w",
					"model": "verge",
					"name": "Verge",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				},
				{
					"category": "Stratos",
					"id": 42,
					"imageName": "stratos_w",
					"imageNamew": "stratos_w",
					"model": "stratos",
					"name": "Stratos 1/3",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				},
				{
					"category": "Amazfit X",
					"id": 43,
					"imageName": "amab7_w",
					"imageNamew": "amab77_w",
					"model": "amazx",
					"name": "X SmartWatch",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				}
		
		]
	},
{
		"typename": "Xiaomi Mi Band Series",
		"typeid": 7000,
		"watchtype": [
		
					{
					"category": "Mi Band 4",
					"id": 44,
					"imageName": "mb4",
					"imageNamew": "mb4",
					"model": "mb4",
					"name": "Mi Band 4",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
					]
				},
				{
					"category": "Mi Band 5",
					"id": 45,
					"imageName": "mb5",
					"imageNamew": "mb5",
					"model": "mb5",
					"name": "Mi Band 5",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
					]
				},
				{
					"category": "Mi Band 6",
					"id": 46,
					"imageName": "mb6",
					"imageNamew": "mb6",
					"model": "mb6",
					"name": "Mi Band 6",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
					]
				},
				{
					"category": "Mi Band 7",
					"id": 47,
					"imageName": "mb7",
					"imageNamew": "mb7",
					"model": "mb7",
					"name": "Mi Band 7",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						},
					{
						"Id": 6,
						"Title": "Zepp Watchface"
					}
					]
				},
				{
					"category": "Mi Band 8",
					"id": 48,
					"imageName": "mb8",
					"imageNamew": "mb8",
					"model": "mb8",
					"name": "Mi Band 8",
					"types": [
						{
							"Id": 1,
							"Title": "Latest"
						},
						{
							"Id": 2,
							"Title": "Random"
						},
						{
							"Id": 3,
							"Title": "Category"
						},
						{
							"Id": 4,
							"Title": "Search"
						}
					]
				}
		
		]
	}			
]
}